import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "detail_content detail_content_bj" }
const _hoisted_2 = { class: "etail_content_bt" }

import { onetThingSavePattrs, sendCode, sendCodeVerify } from "@/config/request";
import { ElMessage } from "element-plus";
import { nextTick, reactive, toRefs } from "vue";
import Nav from "./nav.vue";
const timeout = 60  //  验证码点击之后再次可以点击间隔时间(s)

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    publicData: Object
},
  setup(__props, { expose: __expose }) {

const props = __props
const data = reactive({
    itemList:[],
    counter: 0,         //  倒计时计数器
    codeInput:'',       //  用户输入的验证码
    text: '获取验证码',  //  获取验证码的按钮显示文字
    disabled: false,    //  获取验证码置灰
    numSix: (Math.floor(Math.random()*900000)+ 100000)+'',   //  短信验证码
})
data.counter = timeout
const { publicData } = toRefs(props) as any

const getCode = async() => {
    if(!data.disabled){
        let param = {
            userphone: publicData.value.basicInfo.preApasinfo.telphone,
            code: data.numSix,
        }
        data.disabled = true
        data.text = `验证码(${data.counter})`
        let intervalNum = setInterval(()=>{
            data.counter--
            data.text = `验证码(${data.counter})`
            if(data.counter < 1){
                clearInterval(intervalNum)
                data.text = '获取验证码'
                data.counter = timeout
                data.disabled = false
            }
        },1000)
        const res = await sendCodeVerify(param)
        console.log('发短信res',res);
    }
}

const check = async() => {
    console.log('check的publicData.value',publicData.value);

    let status = 200
    console.log('data.numSix',data.numSix);
    console.log('data.codeInput',data.codeInput);
    
    if(data.numSix && data.numSix === data.codeInput){
        ElMessage.success('验证码验证成功')
        let saveParam = {
            key: JSON.stringify(publicData.value)
        }
        console.log('saveParam----',saveParam);

        let res = await onetThingSavePattrs(saveParam) as any
        console.log('onetThingSavePattrs返回值：', res);
        if (res.success) {
            ElMessage.success(res.message)
            let param = {
                telephone: publicData.value.basicInfo.preApasinfo.telphone,
                projname: publicData.value.oneThing.modelName,
                projid: publicData.value.basicInfo.preApasinfo.projid,
                type:'2',
                receiver:publicData.value.basicInfo.preApasinfo.applyname,
                projpwd:publicData.value.basicInfo.preApasinfo.projpwd,
            };
            let res2 = await sendCode(param)
            console.log('sendCode返回值',res2);
        }else{
            status = 500
            ElMessage.error('信息保存失败')
        }

    }else{
        status = 500
        ElMessage.error('验证码验证失败')
    }
    let result = {
        data: publicData.value,
        status: status
    }
    return result

}

__expose({
    check
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Nav),
    _createElementVNode("div", _hoisted_1, [
      _cache[6] || (_cache[6] = _createElementVNode("h1", { style: {"color":"#2185F2"} }, "网上办事承诺书", -1)),
      _cache[7] || (_cache[7] = _createElementVNode("p", {
        class: "detail_til",
        style: {"font-weight":"bold"}
      }, "本单位（本人）自愿申请成为“网上办事大厅”用户，并郑重承诺如下：", -1)),
      _cache[8] || (_cache[8] = _createElementVNode("p", null, "本单位（本人）同意并接受《网上办事服务条款》所有内容。", -1)),
      _cache[9] || (_cache[9] = _createElementVNode("p", null, "在取得“网上办事大厅”合法用户身份后，应妥善管理用户密码及数字证书，严格遵循国家有关法规、政策及社保业务规范，保证提交业务数据及资料的真实、准确，并对有关资料妥善留存、归档，按业务审批机构要求提供审验。 ", -1)),
      _cache[10] || (_cache[10] = _createElementVNode("p", null, "如违反以上承诺造成的不良后果，本单位（本人）行为将纳入不良诚信记录,并承担全部责任。", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, [
          _createTextVNode("代办人手机号码： " + _toDisplayString(_unref(publicData).basicInfo.preApasinfo.telphone) + " ", 1),
          _createElementVNode("a", {
            onClick: getCode,
            style: _normalizeStyle({background:data.disabled === true ? '#bbb' : ''})
          }, _toDisplayString(data.text), 5)
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("span", null, "手机验证码：", -1)),
        _cache[3] || (_cache[3] = _createTextVNode()),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "请输入验证码",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.codeInput) = $event))
        }, null, 512), [
          [_vModelText, data.codeInput]
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
        _cache[5] || (_cache[5] = _createElementVNode("span", { style: {"color":"#E33232"} }, "注：本承诺书经用户签署后立即生效，直至注销其用户资格为止。", -1))
      ])
    ])
  ], 64))
}
}

})